import React from 'react';
import { selectApartment, selectView } from '.';
import { connect } from 'react-redux';
import ApartmentDropDown from './ApartmentDropDown';


function ButtonResidencesView ( { data, selectView } ) {
  return (
      <ApartmentDropDown data={data} selectView={selectView} />
  );
}



const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  selectView: (apartment) => dispatch(selectView(apartment))
});

export default connect(mapStateToProps, mapDispatchToProps)(ButtonResidencesView);